import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useIntl } from 'react-intl';
import { v4 } from 'uuid';
import { UploadIcon } from '@panwds/icons';
import { Button } from '../Button/Button.esm.js';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import '@headlessui/react';
import '../../utils/constants.esm.js';
import { Subtitle } from '../Typography/Subtitle.esm.js';

const FileUpload = ({ onFiles, multiple = true, disabled = false, acceptFiles, className, dataTestId, dataMetrics, title = useIntl().formatMessage({ id: "CZnN//", defaultMessage: [{ type: 0, value: "File Upload" }] }), dragActiveText = useIntl().formatMessage({ id: "FUmPnF", defaultMessage: [{ type: 0, value: "Drop file here to upload" }] }), dragAreaText, buttonLabel = useIntl().formatMessage({ id: "QmkMlT", defaultMessage: [{ type: 0, value: "Browse File" }] }), separatorLabel = useIntl().formatMessage({ id: "mlsLjA", defaultMessage: [{ type: 0, value: "or" }] }), children, }) => {
    const onDrop = useCallback((acceptedFiles) => {
        const mappedFiles = acceptedFiles.map((file) => {
            return {
                id: v4(),
                file,
                progress: 0,
                progressType: "pending",
                errorMessage: "",
            };
        });
        onFiles(mappedFiles);
    }, []);
    const fileValidator = (file) => {
        var _a, _b, _c;
        if (acceptFiles &&
            !(acceptFiles === null || acceptFiles === void 0 ? void 0 : acceptFiles.split(",").includes((_c = `.${(_b = (_a = file.name) === null || _a === void 0 ? void 0 : _a.split(".")) === null || _b === void 0 ? void 0 : _b.pop()}`) !== null && _c !== void 0 ? _c : ""))) {
            return {
                code: "file-type-not-allowed",
                message: `Only ${acceptFiles} types are allowed`,
            };
        }
        return null;
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple,
        disabled,
        validator: fileValidator,
    });
    const oneFile = useIntl().formatMessage({ id: "q0kbh6", defaultMessage: [{ type: 0, value: "Drag and drop one file here" }] });
    const multipleFiles = useIntl().formatMessage({ id: "ngJP7p", defaultMessage: [{ type: 0, value: "Drag and drop one or more files here" }] });
    return (React.createElement("div", null,
        title && (React.createElement(Subtitle, { size: "lg", addClassName: "tw-space-x-1 tw-block tw-mb-1 tw-text-xs tw-leading-5 tw-font-lato tw-font-bold" }, title)),
        React.createElement("div", { ...getRootProps(), "data-testid": dataTestId || "file-upload", "data-metrics": dataMetrics, className: className },
            React.createElement("input", { ...getInputProps(), "data-testid": "dropzone", id: "uploadLabel" }),
            isDragActive ? (React.createElement("div", { className: "tw-flex tw-p-4 tw-border-dashed tw-border tw-h-24 tw-border-gray-400 dark:tw-border-gray-800 tw-justify-center tw-items-center tw-bg-gray-100 tw-gap-1 tw-rounded tw-flex-col" },
                React.createElement(Subtitle, { size: "lg", addClassName: "tw-text-center tw-text-xs tw-font-normal tw-text-secondary tw-font-lato tw-p-0 tw-m-0" }, dragActiveText))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `tw-flex tw-p-4 tw-border-dashed tw-border tw-h-24 
            ${disabled
                        ? "tw-bg-gray-100/[.40] dark:tw-bg-gray-1000/[.40] tw-cursor-not-allowed tw-border-gray-400/[.40] dark:tw-border-gray-800/[.40]"
                        : "tw-border-gray-400 dark:tw-border-gray-800 tw-bg-white dark:tw-bg-gray-1050 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-1000 dark:tw-bg-gray-1050"}
              tw-justify-center tw-items-center tw-gap-2 tw-rounded tw-flex-col` },
                    React.createElement(Subtitle, { size: "lg", addClassName: `tw-text-center tw-text-xs tw-font-normal ${disabled
                            ? "tw-text-secondary/[.40] dark:tw-text-gray-300/[.40]"
                            : "tw-text-secondary dark:tw-text-gray-300"} tw-font-lato tw-p-0 tw-m-0` }, dragAreaText || (!multiple ? oneFile : multipleFiles)),
                    React.createElement(Subtitle, { size: "lg", addClassName: `tw-text-center tw-text-xs ${disabled
                            ? "tw-text-secondary/[.40] dark:tw-text-gray-300/[.40]"
                            : "tw-text-secondary dark:tw-text-gray-300"} tw-font-lato tw-p-0 tw-m-0` }, separatorLabel),
                    React.createElement(Button, { size: "sm", fullWidth: false, disabled: disabled, icon: React.createElement(UploadIcon, { size: "sm" }), appearance: "secondary" }, buttonLabel))))),
        children));
};

export { FileUpload };
//# sourceMappingURL=FileUpload.esm.js.map
